import { render, staticRenderFns } from "./AlertImmutableMessage.vue?vue&type=template&id=17886335&scoped=true&"
import script from "./AlertImmutableMessage.vue?vue&type=script&lang=js&"
export * from "./AlertImmutableMessage.vue?vue&type=script&lang=js&"
import style0 from "./AlertImmutableMessage.vue?vue&type=style&index=0&id=17886335&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17886335",
  null
  
)

export default component.exports